<script lang="ts">
  import type { Game } from '$lib/types';
  import { createEventDispatcher } from 'svelte';
  import OnIntersect from '$components/OnIntersect.svelte';
  import { ProgressiveImage } from '$mds/Image';

  export let game: Game;
  export let lazyload = false;
  export let showTitle = false;
  export let useAspectRatio = false;
  export let toWatchPage = false;
  export let tag = 'a';
  export let rounded = '';
  export let transition =
    'scale-100 transition-all duration-700 ease-spring-out group-hover:scale-105 group-hover:[transform:rotateX(12deg)_scale(1.1)] shadow-md shadow-transparent origin-bottom group-hover:shadow-black/50';
  export let truncate = 'md:truncate';
  export let textSize = '';
  export let animate3D = false;

  const dispatch = createEventDispatcher();
  const { slug, title, poster } = game;

  let renderImage = !lazyload;

  // Card elements for animation
  let cardElement: HTMLElement;
</script>

<OnIntersect
  instant
  on:change={({ detail }) => {
    if (!renderImage && lazyload && detail) {
      renderImage = true;
    }
  }}
  class="{animate3D ? 'hover:z-60 relative z-10' : ''} {useAspectRatio ? 'w-full' : ''}"
>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <svelte:element
    this={tag}
    class="perspective focus:ring-ondark-focused block h-full w-full rounded-lg outline-none focus:ring-2"
    {...{ ...(tag === 'a' ? { href: `/${slug}${toWatchPage ? '/watch' : ''}` } : {}) }}
    on:click={() => dispatch('click', { ...game })}
  >
    <article class="perspective group flex flex-col">
      <!-- IMAGE -->
      <div
        bind:this={cardElement}
        class="perspective relative {animate3D ? 'hover:z-60 relative shadow-md hover:shadow-xl' : ''} {useAspectRatio
          ? 'aspect-[20/27] h-full'
          : 'h-[250px] md:h-[220px]'} bg-ondark-medium flex items-center justify-center rounded-lg"
      >
        {#if renderImage && !animate3D}
          <ProgressiveImage
            src={poster}
            alt={title?.en}
            sizes={{ xs: 180, sm: 240, md: 360 }}
            class="!h-full !w-full object-cover"
            wrapClass="w-full aspect-[20/27] {transition}"
            aspect={useAspectRatio ? 20 / 27 : undefined}
            {rounded}
          />
        {/if}
      </div>

      <!-- TITLE -->
      {#if showTitle && title?.en}
        <p
          class="tracking-0.01 text-ondark-subtle md:group-hover:text-ondark-primary md:group-hover:scale mt-3 transition-all duration-300 {textSize} {truncate}"
          title={title.en}
        >
          {title.en}
        </p>
      {/if}
    </article>
  </svelte:element>
</OnIntersect>

<style>
  .perspective {
    perspective: 1000px;
  }
</style>
